import SPACING_UNIT from '../constants/global';

const spacing = (factor: number) => `${SPACING_UNIT * factor}px`;

export default spacing;
